import React from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import { Link, Typography } from "@bca/ui-library";

import ChartLineSVG from "./Icons/ChartLineSVG";
import KeyDecisionMakerContainer from "./KeyDecisionMakerContainer";
import useSourcePage from "../hooks/useSourcePage";
import { KeyDecisionMakerText } from "./mechanicalReport/styledElements/KeyDecisionMakerText";

const StyledLink = styled(Link)`
  ${css({
    fontSize: "body-small",
    textAlign: "center",
    paddingRight: [10, 0],
  })}
`;

interface GuidePriceProps {
  price?: string;
  anchorLink?: string;
  soldDate?: string | null;
}

const GuidePrice: React.FunctionComponent<GuidePriceProps> = ({
  price = "-",
  anchorLink,
  soldDate = null,
}) => {
  const { isVPSoldSourcePage } = useSourcePage();

  if (price === "-" || price === "") {
    return null;
  }

  const formattedPrice = price.replace(/\s/g, "");

  return (
    <KeyDecisionMakerContainer>
      <KeyDecisionMakerText>
        <ChartLineSVG width="24px" height="24px" />
        <Typography variant="h6" color="footer-blue" m={0}>
          {formattedPrice}
        </Typography>
      </KeyDecisionMakerText>
      <StyledLink
        href={anchorLink ? anchorLink : null}
        color="primary-light-blue"
        underline="always"
        analytics={{
          eventLabel: "pricing",
          eventAction: "navigate",
          eventSection: "primary-information",
        }}
      >
        CAP Clean
      </StyledLink>
      {isVPSoldSourcePage && Boolean(soldDate) && (
        <Typography variant="body-small" margin={0}>
          Pricing from date of sale
        </Typography>
      )}
    </KeyDecisionMakerContainer>
  );
};

export default GuidePrice;
